import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 4.08333C2.5 3.20888 3.20888 2.5 4.08333 2.5H25.9167C26.7911 2.5 27.5 3.20888 27.5 4.08333V25.9167C27.5 26.7911 26.7911 27.5 25.9167 27.5H4.08333C3.20888 27.5 2.5 26.7911 2.5 25.9167V4.08333Z",
      stroke: "currentColor",
      "stroke-width": "1.58333"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.48 20C13.1635 20 14.5573 19.3923 15.468 18.2735L14.0329 16.9475C13.3843 17.7072 12.5701 18.0939 11.6042 18.0939C9.79645 18.0939 8.51311 16.8232 8.51311 15C8.51311 13.1768 9.79645 11.9061 11.6042 11.9061C12.5701 11.9061 13.3843 12.2928 14.0329 13.0387L15.468 11.7127C14.5573 10.6077 13.1635 10 11.4938 10C8.48551 10 6.25 12.0856 6.25 15C6.25 17.9144 8.48551 20 11.48 20Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.1025 19.9448C22.4622 19.9448 24.1733 18.3564 24.1733 16.1188C24.1733 13.8812 22.4622 12.2928 20.1025 12.2928C17.7428 12.2928 16.0178 13.8812 16.0178 16.1188C16.0178 18.3564 17.7428 19.9448 20.1025 19.9448ZM20.1025 18.1768C19.0261 18.1768 18.1982 17.4033 18.1982 16.1188C18.1982 14.8343 19.0261 14.0608 20.1025 14.0608C21.1788 14.0608 21.993 14.8343 21.993 16.1188C21.993 17.4033 21.1788 18.1768 20.1025 18.1768Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }